import { render, staticRenderFns } from "./SsoComplete.vue?vue&type=template&id=df637736"
import script from "./SsoComplete.vue?vue&type=script&lang=js"
export * from "./SsoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports